let pathDefiners = ['Customer', 'Property'];
//
export const formatParameters = (filterList) => {
    let filterListCopy = [...filterList];
    let filterListKeys = filterList.map((filter) => filter.key);
    let found = pathDefiners.map((definition) => {
        return filterListKeys.includes(definition);
    });
    let index = filterListCopy.findIndex((filter) => pathDefiners.includes(filter.key));
    let match = found.filter((val) => val === true).length;
    if (match === 1) {
        let keyFilter = filterListCopy.splice(index, 1)[0];
        let keyValue = keyFilter.value;
        keyValue = typeof keyValue === 'string' ? keyValue : undefined;
        return [filterListCopy, keyValue];
    }
    else if (match === 0) {
        return [filterList, undefined];
    }
    else {
        filterListCopy = filterListCopy.filter((filters) => !pathDefiners.includes(filters.key));
        return [filterListCopy, undefined];
    }
};
